<template>
  <section>
    <b-row v-if="loading">
      <b-col
        sm="12"
        class="text-center"
      >
        <b-skeleton
          class="d-inline-block"
          animation="wave"
          width="40%"
          height="800px"
        />
      </b-col>
    </b-row>
    <div v-else>
      <scroll-container
        class="pt-2 mt-n30px"
        height-offset="140px"
      >
        <b-container
          class="container-small"
        >
          <b-card class="mb-2">
            <b-form-group
              :label="$tk('ClientPortal.Catalog.SchemaType')"
              label-for="choose-schema-type"
            >
              <v-select
                v-model="wrapper.schemaType"
                name="choose-schema-type"
                :options="catalogTypes"
                label="text"
                :disabled="wrapper.id !== 0"
                taggable
                :clearable="false"
                select-on-tab
                :reduce="f => f.value"
              />
            </b-form-group>
          </b-card>
          <b-card
            class="mb-1"
          >
            <b-form-group
              :label="$tk('ClientPortal.Catalogs.SchemaName')"
              label-for="SchemaName"
              :invalid-feedback="errorMessages.SchemaName"
            >
              <b-form-input
                id="SchemaName"
                v-model="wrapper.schemaName"
                :placeholder="$tk('ClientPortal.Catalogs.SchemaNamePlaceholder')"
                :state="errorMessages['SchemaName'] == null ? null : false"
              />
            </b-form-group>
            <template v-if="isProductSchema">
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.CatalogItemIdName')"
                label-for="CatalogItemIdName"
                :invalid-feedback="errorMessages.CatalogItemIdName"
              >
                <b-form-input
                  id="CatalogItemIdName"
                  v-model="wrapper.catalogItemIdName"
                  :placeholder="$tk('ClientPortal.Catalogs.CatalogItemIdNamePlaceholder')"
                  :state="errorMessages['CatalogItemIdName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ContentIdName')"
                label-for="ContentIdName"
                :invalid-feedback="errorMessages.ContentIdName"
              >
                <b-form-input
                  id="ContentIdName"
                  v-model="wrapper.contentIdName"
                  :placeholder="$tk('ClientPortal.Catalogs.ContentIdNamePlaceholder')"
                  :state="errorMessages['ContentIdName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.TitleName')"
                label-for="TitleName"
                :invalid-feedback="errorMessages.TitleName"
              >
                <b-form-input
                  id="TitleName"
                  v-model="wrapper.titleName"
                  :placeholder="$tk('ClientPortal.Catalogs.TitleNamePlaceholder')"
                  :state="errorMessages['TitleName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.DescriptionName')"
                label-for="DescriptionName"
                :invalid-feedback="errorMessages.DescriptionName"
              >
                <b-form-input
                  id="DescriptionName"
                  v-model="wrapper.descriptionName"
                  :placeholder="$tk('ClientPortal.Catalogs.DescriptionNamePlaceholder')"
                  :state="errorMessages['DescriptionName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.StockName')"
                label-for="StockName"
                :invalid-feedback="errorMessages.StockName"
              >
                <b-form-input
                  id="StockName"
                  v-model="wrapper.stockName"
                  :placeholder="$tk('ClientPortal.Catalogs.StockNamePlaceholder')"
                  :state="errorMessages['StockName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.PriceName')"
                label-for="PriceName"
                :invalid-feedback="errorMessages.PriceName"
              >
                <b-form-input
                  id="PriceName"
                  v-model="wrapper.priceName"
                  :placeholder="$tk('ClientPortal.Catalogs.PriceNamePlaceholder')"
                  :state="errorMessages['PriceName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.PriceWithDiscountName')"
                label-for="PriceWithDiscountName"
                :invalid-feedback="errorMessages.PriceWithDiscountName"
              >
                <b-form-input
                  id="PriceWithDiscountName"
                  v-model="wrapper.priceWithDiscountName"
                  :placeholder="$tk('ClientPortal.Catalogs.PriceWithDiscountNamePlaceholder')"
                  :state="errorMessages['PriceWithDiscountName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ProductUrlName')"
                label-for="ProductUrlName"
                :invalid-feedback="errorMessages.ProductUrlName"
              >
                <b-form-input
                  id="ProductUrlName"
                  v-model="wrapper.productUrlName"
                  :placeholder="$tk('ClientPortal.Catalogs.ProductUrlNamePlaceholder')"
                  :state="errorMessages['ProductUrlName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ImageUrlName')"
                label-for="ImageUrlName"
                :invalid-feedback="errorMessages.ImageUrlName"
              >
                <b-form-input
                  id="ImageUrlName"
                  v-model="wrapper.imageUrlName"
                  :placeholder="$tk('ClientPortal.Catalogs.ImageUrlNamePlaceholder')"
                  :state="errorMessages['ImageUrlName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.BrandName')"
                label-for="BrandName"
                :invalid-feedback="errorMessages.BrandName"
              >
                <b-form-input
                  id="BrandName"
                  v-model="wrapper.brandName"
                  :placeholder="$tk('ClientPortal.Catalogs.BrandNamePlaceholder')"
                  :state="errorMessages['BrandName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.CategoryName')"
                label-for="CategoryName"
                :invalid-feedback="errorMessages.CategoryName"
              >
                <b-form-input
                  id="CategoryName"
                  v-model="wrapper.categoryName"
                  :placeholder="$tk('ClientPortal.Catalogs.CategoryNamePlaceholder')"
                  :state="errorMessages['CategoryName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.OtherImagesUrlsName')"
                label-for="OtherImagesUrlsName"
                :invalid-feedback="errorMessages.OtherImagesUrlsName"
              >
                <b-form-input
                  id="OtherImagesUrlsName"
                  v-model="wrapper.otherImagesUrlsName"
                  :placeholder="$tk('ClientPortal.Catalogs.OtherImagesUrilsNamePlaceholder')"
                  :state="errorMessages['OtherImagesUrlsName'] == null ? null : false"
                />
              </b-form-group>
            </template>
            <template v-if="isVideoSchema">
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.CatalogItemIdName')"
                label-for="CatalogItemIdName"
                :invalid-feedback="errorMessages.CatalogItemIdName"
              >
                <b-form-input
                  id="CatalogItemIdName"
                  v-model="wrapper.catalogItemIdName"
                  :placeholder="$tk('ClientPortal.Catalogs.CatalogItemIdNamePlaceholder')"
                  :state="errorMessages['CatalogItemIdName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ContentIdName')"
                label-for="ContentIdName"
                :invalid-feedback="errorMessages.ContentIdName"
              >
                <b-form-input
                  id="ContentIdName"
                  v-model="wrapper.contentIdName"
                  :placeholder="$tk('ClientPortal.Catalogs.ContentIdNamePlaceholder')"
                  :state="errorMessages['ContentIdName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.TitleName')"
                label-for="TitleName"
                :invalid-feedback="errorMessages.TitleName"
              >
                <b-form-input
                  id="TitleName"
                  v-model="wrapper.titleName"
                  :placeholder="$tk('ClientPortal.Catalogs.TitleNamePlaceholder')"
                  :state="errorMessages['TitleName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.DescriptionName')"
                label-for="DescriptionName"
                :invalid-feedback="errorMessages.DescriptionName"
              >
                <b-form-input
                  id="DescriptionName"
                  v-model="wrapper.descriptionName"
                  :placeholder="$tk('ClientPortal.Catalogs.DescriptionNamePlaceholder')"
                  :state="errorMessages['DescriptionName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ThumbnailUrl')"
                label-for="ThumbnailUrl"
                :invalid-feedback="errorMessages.ThumbnailUrl"
              >
                <b-form-input
                  id="ThumbnailUrl"
                  v-model="wrapper.thumbnailUrl"
                  :placeholder="$tk('ClientPortal.Catalogs.ThumbnailUrlPlaceholder')"
                  :state="errorMessages['ThumbnailUrl'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.SerieName')"
                label-for="SerieName"
                :invalid-feedback="errorMessages.SerieName"
              >
                <b-form-input
                  id="SerieName"
                  v-model="wrapper.serieName"
                  :placeholder="$tk('ClientPortal.Catalogs.SerieNamePlaceholder')"
                  :state="errorMessages['SerieName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.Category')"
                label-for="Category"
                :invalid-feedback="errorMessages.Category"
              >
                <b-form-input
                  id="Category"
                  v-model="wrapper.category"
                  :placeholder="$tk('ClientPortal.Catalogs.CategoryPlaceholder')"
                  :state="errorMessages['Category'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.Duration')"
                label-for="Duration"
                :invalid-feedback="errorMessages.Duration"
              >
                <b-form-input
                  id="Duration"
                  v-model="wrapper.duration"
                  :placeholder="$tk('ClientPortal.Catalogs.DurationPlaceholder')"
                  :state="errorMessages['Duration'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.VideoUrl')"
                label-for="VideoUrl"
                :invalid-feedback="errorMessages.VideoUrl"
              >
                <b-form-input
                  id="VideoUrl"
                  v-model="wrapper.videoUrl"
                  :placeholder="$tk('ClientPortal.Catalogs.VideoUrlPlaceholder')"
                  :state="errorMessages['VideoUrl'] == null ? null : false"
                />
              </b-form-group>
            </template>
            <template v-if="isChannelSchema || isSerieSchema">
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ContentIdName')"
                label-for="ContentIdName"
                :invalid-feedback="errorMessages.ContentIdName"
              >
                <b-form-input
                  id="ContentIdName"
                  v-model="wrapper.contentIdName"
                  :placeholder="$tk('ClientPortal.Catalogs.ContentIdNamePlaceholder')"
                  :state="errorMessages['ContentIdName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ContentName')"
                label-for="ContentName"
                :invalid-feedback="errorMessages.ContentName"
              >
                <b-form-input
                  id="ContentName"
                  v-model="wrapper.contentName"
                  :placeholder="$tk('ClientPortal.Catalogs.ContentNamePlaceholder')"
                  :state="errorMessages['ContentName'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ContentImageUrl')"
                label-for="ContentImageUrl"
                :invalid-feedback="errorMessages.ContentImageUrl"
              >
                <b-form-input
                  id="ContentImageUrl"
                  v-model="wrapper.contentImageUrl"
                  :placeholder="$tk('ClientPortal.Catalogs.ContentImageUrlPlaceholder')"
                  :state="errorMessages['ContentImageUrl'] == null ? null : false"
                />
              </b-form-group>
              <b-form-group
                :label="$tk('ClientPortal.Catalogs.ContentUrl')"
                label-for="ContentUrl"
                :invalid-feedback="errorMessages.ContentUrl"
              >
                <b-form-input
                  id="ContentUrl"
                  v-model="wrapper.contentUrl"
                  :placeholder="$tk('ClientPortal.Catalogs.ContentUrlPlaceholder')"
                  :state="errorMessages['ContentUrl'] == null ? null : false"
                />
              </b-form-group>
            </template>
          </b-card>
        </b-container>
      </scroll-container>
    </div>
    <div class="border-top text-right py-1">
      <b-button
        class="bg-white"
        variant="outline-dark"
        size="sm"
        :disabled="saving"
        :to="`/${$route.params.accountId}/catalogs#catalog-schema-list`"
      >
        {{ $tk('ClientPortal.Form.Actions.Cancel') }}
      </b-button>
      <b-button
        class="bg-white ml-50"
        variant="primary"
        size="sm"
        :disabled="saving || !isFormComplete"
        @click="saveCatalogSchema(wrapper)"
      >
        {{ $tk('ClientPortal.Form.Actions.Save') }}
      </b-button>
    </div>
  </section>
</template>

<script>
import ScrollContainer from '@/components/ScrollContainer.vue'
import CatalogSchemas from '@/api/client/catalogSchemas.service'
import notification from '@/mixins/toastification'
import store from '@/store'
import scrollToError from '@/mixins/scrollToError'
import vSelect from 'vue-select'

const CATALOG_TYPE = {
  PRODUCT: 1,
  VIDEO: 2,
  CHANNEL: 3,
  SERIE: 4,
}

export default {
  components: {
    ScrollContainer,
    vSelect,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    catalogSchemaId: Number,
  },
  data() {
    return {
      wrapper: {},
      errorMessages: {},
      saving: false,
      loading: false,
      catalogTypes: {},
    }
  },
  computed: {
    isProductSchema() {
      return this.wrapper.schemaType === CATALOG_TYPE.PRODUCT
    },
    isVideoSchema() {
      return this.wrapper.schemaType === CATALOG_TYPE.VIDEO
    },
    isChannelSchema() {
      return this.wrapper.schemaType === CATALOG_TYPE.CHANNEL
    },
    isSerieSchema() {
      return this.wrapper.schemaType === CATALOG_TYPE.SERIE
    },
    isFormComplete() {
      const { schemaType, schemaName } = this.wrapper

      return schemaType && schemaName
    },
  },
  watch: {
    '$route.params.accountId': 'fetchData',
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const catalogSchemaId = this.catalogSchemaId !== undefined ? parseInt(this.catalogSchemaId, 10) : 0
        const response = await CatalogSchemas.getCatalogSchema(catalogSchemaId, this.$route.params.accountId)
        this.wrapper = response.schema
        this.catalogTypes = response.catalogTypes
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loading = false
        if (this.wrapper.schemaJson) this.wrapper = Object.assign(this.wrapper, JSON.parse(this.wrapper.schemaJson))
      }
    },
    async saveCatalogSchema(model) {
      this.saving = true
      const newModel = {}
      const ignoredProps = ['id', 'accountId', 'schemaName', 'schemaType', 'catalogTypes']
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(model)) {
        // eslint-disable-next-line no-continue
        if (ignoredProps.includes(key)) { continue }
        newModel[key] = value
      }
      const schema = {
        id: model.id,
        accountId: this.$route.params.accountId,
        schemaName: model.schemaName,
        schemaType: model.schemaType,
        schemaJson: JSON.stringify(newModel),
      }
      try {
        const response = await CatalogSchemas.createCatalogSchema(schema, this.$route.params.accountId)
        if (response.saved) {
          if (this.catalogSchemaId === 0) {
            store.commit('app/TOGGLE_NEW_CREATE_STATE', true)
            this.success(response.message)
            this.$router.push(`/${this.$route.params.accountId}/catalogs#catalog-schema-list`)
          } else {
            this.success(response.message)
            this.$router.push(`/${this.$route.params.accountId}/catalogs#catalog-schema-list`)
          }
        } else {
          this.error(response.message)
          this.errorMessages = response.errors
        }
      } catch (error) {
        this.error(error.message)
      } finally {
        scrollToError(this.errorMessages)
        this.saving = false
      }
    },
  },
}
</script>
